<template>
  <b-overlay :show="loading" rounded="sm">
    <b-card no-body class="card-shadow border-0 width-card" @click="linkRota != '' ? $router.push({ name: linkRota, query: { statusPedido: statusPedido } }) : ''">
      <b-row no-gutters>
        <b-col
          cols="3"
          :class="`d-flex align-items-center justify-content-center rounded-left width-card ${backgroundColor}`"
        >
          <i :class="`${icon} ${iconSize} ${iconColor}`"></i>
        </b-col>
        <b-col cols="9">
          <b-card-body>
            <b-card-title class="c-black font-weight-bold fs-16">
              {{ title }}
            </b-card-title>
            <b-card-text class="fs-24">
              {{ formatToMoney ? formatNumber(number) : number }}
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import { formatNumber } from '../../../utils/index.js';

export default {
  name: 'DashboardHomeCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconSize: {
      type: String,
      default: 'fs-28',
    },
    iconColor: {
      type: String,
      default: 'c-white',
    },
    backgroundColor: {
      type: String,
      required: true,
    },
    number: {
      type: Number,
      default: 0,
    },
    formatToMoney: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    linkRota: {
      type: String,
      required: false,
      default: ''
    },
    statusPedido: {
      type: String,
      required: false,
      default: ''
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<style scoped>
.card-shadow {
  box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.2);
}
.width-card {
  height: 135px;
}
</style>